# Подписи выбранного контента одним запросом (фильтр ids): только id и
# название, без тяжёлых полей одиночного ContentQuery.
query ContentTitles($ids: [ID!]!, $rowsPerPage: Int) {
  contents(page: 0, rowsPerPage: $rowsPerPage, filter: { ids: $ids }) {
    nodes {
      id
      title
    }
  }
}
